import { combineReducers } from 'redux';
import { SetCities, SetCityDepartures } from './reducer_cities';
import { CurrentBooking } from './reducer_currentBooking';
import { SetLoading } from './reducer_utils';

const rootReducer = combineReducers({
    cities:SetCities,
    allDepartures:SetCityDepartures,
    currentBooking:CurrentBooking,
    isLoading:SetLoading
});
  
export default rootReducer;